import script from "./MakeNominationsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeNominationsBox.vue?vue&type=script&setup=true&lang=js"

import "./MakeNominationsBox.vue?vue&type=style&index=0&id=e7646046&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7646046"]])

export default __exports__